/* Trustpilot reviews — "Meer reviews laden" op mobiel (grid).
   Items boven het startaantal zijn server-side al verborgen op mobiel
   (.tp-grid__item--mobile-hidden). Deze knop onthult ze in batches. */
(function () {
  if (window.__tpLoadMoreBound) return;
  window.__tpLoadMoreBound = true;

  function bind() {
    document.querySelectorAll('[data-tp-loadmore]').forEach(function (grid) {
      if (grid.dataset.tpBound) return;
      grid.dataset.tpBound = '1';

      var wrap = grid.parentElement;
      var btn = wrap ? wrap.querySelector('.tp-load-more') : null;
      if (!btn) return;

      var increment = parseInt(grid.getAttribute('data-tp-increment'), 10) || 4;

      function remaining() {
        return grid.querySelectorAll('.tp-grid__item--mobile-hidden:not(.is-shown)');
      }
      function syncButton() {
        if (remaining().length === 0) {
          btn.classList.add('is-done');
        } else {
          btn.classList.remove('is-done');
        }
      }

      btn.addEventListener('click', function () {
        var hidden = remaining();
        for (var i = 0; i < increment && i < hidden.length; i++) {
          hidden[i].classList.add('is-shown');
        }
        syncButton();
      });

      syncButton();
    });
  }

  if (document.readyState !== 'loading') {
    bind();
  } else {
    document.addEventListener('DOMContentLoaded', bind);
  }
})();
